export default "__VITE_ASSET__Bk2Q87EB__"